let dataCache = {};
let dataCacheKeys = [];
let dataCacheSize = 30;

// Puts a data file into the data cache.
export function setDataCache(data, url) {
    dataCache[url] = data;
    dataCacheKeys.push(url);
    if (dataCacheKeys.length > dataCacheSize) {
        let oldestKey = dataCacheKeys.shift();
        delete dataCache[oldestKey];
    }
}

//in case some pages need more 
//and for easier testing
export function changeCacheSize(num) {
    dataCacheSize = num
}

export function getFromCache(url) {
    return dataCache[url]
}

export function hasCacheData(url) {
    return (url in dataCache)
}

export function resetCache() {
    dataCache = {}
    dataCacheKeys = []
    dataCacheSize = 30
}